import { CommonModule } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { environment } from 'environments/environment';
import { PdfViewerModule } from 'ng2-pdf-viewer';
export interface DialogData {
  dcURL: string;
}

@Component({
  selector: 'app-doc-viewer',
  templateUrl: './doc-viewer.component.html',
  styleUrls: ['./doc-viewer.component.scss'],
  standalone: true,
  imports: [CommonModule, PdfViewerModule, MatIconModule, MatButtonModule],

})
export class DocViewerComponent {
  docData = null;
  fileType = '';
  fileExtn = '';
  constructor(
    public dialogRef: MatDialogRef<DocViewerComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    console.log("PDF VIEWR ----------- ", data);
    this.docData = data;
    this.findFileType(this.docData.dcURL)
  }

  cancleDcVwr() {
    this.dialogRef.close();
  }

  downloadPDF(url) {
    window.open(url);
  }

  findFileType(url) {
    if (url && typeof url == "string") {

      if (url.match(/amazonaws/) && url.match(/amazonaws/).length) {

      }
      else {
        if (!url.match(/localhost/)) {
          url = `${environment.apiOrigin}${url}`;
          this.docData.dcURL = url;
        }
      }

      let t = url.split('.');
      let extn = t[t.length - 1];
      this.fileExtn = extn;
      if (extn.match(/pdf/) && extn.match(/pdf/).length) {
        this.fileType = "pdf";
      }
      else if (extn.match(/png|jpeg|jpg|gif/) && extn.match(/png|jpeg|jpg|gif/).length) {
        this.fileType = "image";
      }
      else {
        this.fileType = "NA";
      }
    }

  }
  printPdf(url, event: Event) {
    console.log(url);
    const srvrUrl = `${url}`;
    const req = new XMLHttpRequest();
    req.open('GET', srvrUrl, true);
    req.responseType = 'blob';
    req.onload = () => {
      if (req.status === 200) {
        const blobUrl = URL.createObjectURL(req.response);
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = blobUrl;
        document.body.appendChild(iframe);
        iframe.onload = () => {
          setTimeout(() => {
            iframe.contentWindow?.print();
          }, 100);
        };
      } else {
        console.error(req.statusText);
      }

      console.log(req.response);
    };

    req.onerror = () => {
      console.error('Request failed');
    };

    req.send();
  }
}
